import { get } from "lodash"
import { OK, ERROR } from "helpers/data-statuses"

const EMPTY_ARRAY = []

// Passthrough resources persist across account switches. Guard against serving stale data by
// verifying the stored request URL belongs to the currently-selected account before reading it.
function getPassthroughSkillsData(state, resource, key) {
  const account = get(state, "global.selected.account")
  const id = get(state, `global.data.${resource}.id`)
  if (!account || !id || !id.startsWith(`/api/${account}/`)) return EMPTY_ARRAY
  return get(state, `global.data.${resource}.data.${key}`, EMPTY_ARRAY) || EMPTY_ARRAY
}

export const getLicensedSkills = state => getPassthroughSkillsData(state, "licensedSkills", "skills")
export const getProprietarySkills = state => getPassthroughSkillsData(state, "proprietarySkills", "skills")

// Canonical category display order, sourced from op-llm-skills via the server response.
// Prefer the licensed catalog's order; fall back to the proprietary catalog's.
export function getSkillCategoryOrder(state) {
  const licensed = getPassthroughSkillsData(state, "licensedSkills", "categories")
  return licensed.length ? licensed : getPassthroughSkillsData(state, "proprietarySkills", "categories")
}

function getSkillsStatuses(state) {
  const account = get(state, "global.selected.account")
  if (!account) return null

  const licensedId = get(state, "global.data.licensedSkills.id")
  const proprietaryId = get(state, "global.data.proprietarySkills.id")

  // If either resource ID doesn't belong to the current account, the data is stale.
  const expectedPrefix = `/api/${account}/`
  if (!licensedId?.startsWith(expectedPrefix) || !proprietaryId?.startsWith(expectedPrefix)) {
    return null
  }

  return {
    licensed: get(state, "global.data.licensedSkills.status"),
    proprietary: get(state, "global.data.proprietarySkills.status"),
  }
}

export const isSkillsLoaded = state => {
  const statuses = getSkillsStatuses(state)
  if (!statuses) return false
  return (statuses.licensed === OK || statuses.licensed === ERROR)
    && (statuses.proprietary === OK || statuses.proprietary === ERROR)
}

export const isSkillsError = state => {
  const statuses = getSkillsStatuses(state)
  if (!statuses) return false
  return statuses.licensed === ERROR || statuses.proprietary === ERROR
}
